export interface ChannelPresence {
  hasRegular: boolean
  hasSubscription: boolean
  hasBoth: boolean
}

export interface StudioChannelSignal {
  hasRegularFact: boolean
  hasSubscriptionFact: boolean
  hasRegularPlan: boolean
  hasSubscriptionPlan: boolean
}

export function hasPositiveNumber(value: number | null | undefined): boolean {
  return Number.isFinite(value) && (value as number) > 0
}

export function hasAnyPositive(values: Array<number | null | undefined>): boolean {
  return values.some((value) => hasPositiveNumber(value))
}

export function getChannelPresence(
  regularValues: Array<number | null | undefined>,
  subscriptionValues: Array<number | null | undefined>
): ChannelPresence {
  const hasRegular = hasAnyPositive(regularValues)
  const hasSubscription = hasAnyPositive(subscriptionValues)

  return {
    hasRegular,
    hasSubscription,
    hasBoth: hasRegular && hasSubscription
  }
}

export function hasBothChannelsByStudioSignals(signals: Iterable<StudioChannelSignal>): boolean {
  for (const signal of signals) {
    const hasRegular = signal.hasRegularFact || signal.hasRegularPlan
    const hasSubscription = signal.hasSubscriptionFact || signal.hasSubscriptionPlan
    if (hasRegular && hasSubscription) {
      return true
    }
  }

  return false
}
